import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/api';

function SubscriptionAlert() {
    const navigate = useNavigate();
    const [subscription, setSubscription] = useState(undefined);
    const [dismissed, setDismissed] = useState(false);
    const isSuperAdmin = localStorage.getItem('isSuperAdmin') === 'true';

    useEffect(() => {
        if (isSuperAdmin) return;
        loadSubscription();

        const interval = setInterval(() => {
            loadSubscription();
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    const loadSubscription = async () => {
        try {
            const response = await API.get('/subscriptions/my-subscription');
            const data = response.data.data;
            if (!data || !data.plan_name) {
                setSubscription(null);
            } else {
                setSubscription(data);
            }
        } catch (error) {
            console.error('Subscription check error:', error);
            setSubscription(null);
        }
    };

    if (isSuperAdmin) return null;
    if (dismissed) return null;
    if (subscription === undefined) return null;
    if (
        window.location.pathname === '/checkout' ||
        window.location.pathname === '/pricing' ||
        window.location.pathname.startsWith('/flow-builder')
    ) return null;

    // No subscription
    if (!subscription) {
        return (
            <div className="sub-alert sub-alert-warning">
                <span className="sub-alert-text">
                    ⚠️ <strong>No Active Subscription</strong> — Your account has limited access.
                </span>
                <div className="sub-alert-actions">
                    <button
                        onClick={() => navigate('/pricing')}
                        className="sub-alert-btn sub-alert-btn-warning"
                    >
                        Subscribe Now →
                    </button>
                    <button onClick={() => setDismissed(true)} className="sub-alert-close">✕</button>
                </div>
            </div>
        );
    }

    const endDate = new Date(subscription.end_date);
    const today = new Date();
    const daysLeft = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));

    // ✅ formattedExpiry pehle define karo — sab blocks mein use hoga
    const formattedExpiry = endDate.toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });

    // ✅ Subscription expired
    if (daysLeft <= 0) {
        return (
            <div className="sub-alert sub-alert-danger">
                <span className="sub-alert-text">
                    ❌ <strong>Subscription Expired!</strong> — Your plan ended on {formattedExpiry}. All features are disabled.
                </span>
                <div className="sub-alert-actions">
                    <button
                        onClick={() => navigate('/pricing')}
                        className="sub-alert-btn sub-alert-btn-danger"
                    >
                        Renew Now →
                    </button>
                </div>
            </div>
        );
    }

    // ✅ Expiring soon (within 7 days)
    if (daysLeft <= 7 && daysLeft > 0) {
        return (
            <div className="sub-alert sub-alert-danger">
                <span className="sub-alert-text">
                    🚨 <strong>Subscription Expiring Soon!</strong> — {daysLeft} day{daysLeft !== 1 ? 's' : ''} left. Plan: {subscription.plan_name}
                </span>
                <div className="sub-alert-actions">
                    <button
                        onClick={() => navigate('/pricing')}
                        className="sub-alert-btn sub-alert-btn-danger"
                    >
                        Renew Now →
                    </button>
                    <button onClick={() => setDismissed(true)} className="sub-alert-close">✕</button>
                </div>
            </div>
        );
    }

    // ✅ Active subscription
    return (
        <div className="sub-alert sub-alert-active">
            <span className="sub-alert-text">
                ✅ <strong>{subscription.plan_name} Plan</strong> — Active &nbsp;|&nbsp; Expires: {formattedExpiry} &nbsp;|&nbsp; {daysLeft} days remaining
            </span>
            <div className="sub-alert-actions">
                <button onClick={() => setDismissed(true)} className="sub-alert-close sub-alert-close-active">✕</button>
            </div>
        </div>
    );
}

export default SubscriptionAlert;